(function () {
  'use strict';

  angular.module('ringbaPortal').component('callPlans', {
    controller: CallPlansController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/call-plans/call-plans.view.html'
  });

  function CallPlansController(
    $q,
    _,
    $scope,
    $translate,
    $timeout,
    $uibModal,
    $stateParams,
    accountsService,
    bsLoadingOverlayService,
    callPlanService,
    isMobileDevice,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.showRoutes = showRoutes;
    vm.hideRoutes = hideRoutes;
    vm.onCreate = onCreate;
    vm.onUpdate = onUpdate;
    vm.onNewCallPlanRoutesClose = onNewCallPlanRoutesClose;
    vm.onAddingNewRouteToNewCallPlan = onAddingNewRouteToNewCallPlan;
    vm.getCallPlanRoutes = getCallPlanRoutes;
    vm.activateCallPlanActions = activateCallPlanActions;
    vm.confirmDeleteModal = confirmDeleteModal;
    vm.confirmDelete = confirmDelete;
    vm.cancelModal = cancelModal;
    vm.duplicateCallPlan = duplicateCallPlan;

    function onInit() {
      vm.activeCallPlan = null;
      vm.showSpecificRecordDetails = $stateParams.callPlanId;
      vm.canCreateCallPlan = accountsService.hasAccess('CallPlan', 'CREATE');
      vm.loading = true;
      vm.isMobileView = isMobileDevice;
      _setViewDetails(vm.showSpecificRecordDetails);
      _loadData();
    }

    function showForm(callPlan) {
      if (vm.activeCallPlan && vm.activeCallPlan.showRoutes) hideRoutes(vm.activeCallPlan);
      if (!vm.showSpecificRecordDetails) {
        if (vm.activeCallPlan) hideForm(vm.activeCallPlan);
        vm.activeCallPlan = callPlan;
      }
      if (callPlan) {
        vm.showAddNewForm = false;
        callPlan.showEditForm = true;
      } else {
        vm.showAddNewForm = true;
      }
      vm.activeActionCallPlanId = false;
      vm.formActive = true;
    }

    function hideForm(callPlan) {
      if (callPlan) {
        callPlan.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.activeCallPlan = null;
      vm.formActive = false;
    }

    function showRoutes(callPlan) {
      if (!vm.formActive) {
        vm.formActive = true;
        callPlan.showRoutes = true;
        vm.activeCallPlan = callPlan;
        vm.activeActionCallPlanId = false;
      }
    }

    function hideRoutes(callPlan) {
      vm.formActive = false;
      vm.activeCallPlan = null;
      delete callPlan.showRoutes;
    }

    function onCreate(callPlan) {
      vm.routesForCallPlan = callPlan;
      vm.showNewCallPlanRoutes = true;
    }

    function onUpdate() {
      _loadData();
    }

    function onNewCallPlanRoutesClose() {
      vm.showNewCallPlanRoutes = false;
      vm.isNewRouteAddedToCallPlan = false;
      vm.routesForCallPlan = undefined;
      hideForm();
      _loadCallPlans();
    }

    // Here routeContainer argument is the callPlan
    function onAddingNewRouteToNewCallPlan(routeContainer) {
      vm.isNewRouteAddedToCallPlan = true;
      vm.routesForCallPlan = routeContainer;
      getCallPlanRoutes(routeContainer);
    }

    // Here routeContainer argument is the callPlan
    function getCallPlanRoutes(routeContainer) {
      callPlanService.getCallRoutes(accountsService.currentAccountId, routeContainer.id).then(function (response) {
        routeContainer.routes = response.data.routes;
        vm.routesForCallPlan = vm.routesForCallPlan && routeContainer;
      }).catch(utils.errorHandler);
    }

    function activateCallPlanActions(callPlanId) {
      vm.activeActionCallPlanId = vm.activeActionCallPlanId == callPlanId ? false : callPlanId;
    }

    function confirmDeleteModal(callPlan) {
      if (!vm.formActive) {
        vm.callPlanReferences = null;
        vm.callPlanForDelete = callPlan;
        _getCallPlanReferences(callPlan.id);
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/call-plans/delete-call-plan.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function confirmDelete(hasReferences) {
      if (!hasReferences) {
        return callPlanService.deleteCallPlan(accountsService.currentAccountId, vm.callPlanForDelete.id).then(
          function () {
            toaster.pop('success', $translate.instant('DELETE_CALL_PLAN_SUCCESSFUL_MESSAGE'));
            _.remove(vm.callPlans, function (callPlan) {
              return callPlan.id === vm.callPlanForDelete.id;
            });
            cancelModal();
          }).catch(utils.errorHandler);
      } else {
        cancelModal();
        return $q.when();
      }
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.callPlanForDelete = null;
      }
    }

    function duplicateCallPlan(callPlanId) {
      if (!vm.formActive) {
        vm.loading = true;
        vm.callPlans = false;
        return callPlanService.duplicateCallPlan(accountsService.currentAccountId, callPlanId).then(
          function () {
            _loadCallPlans();
          }
        );
      }
    }

    function _getCallPlanReferences(callPlanId) {
      vm.checkReferencesText = 'DELETE_CALL_PLAN_MODAL_CALL_PLAN_CHECK_ASSOCIATION_TEXT';
      bsLoadingOverlayService.start();
      callPlanService.getInboundReferences(accountsService.currentAccountId, callPlanId).then(function (response) {
        // We're using timeout here to show the user the checking call plan references text
        $timeout(function () {
          bsLoadingOverlayService.stop();
          vm.callPlanReferences = _deDupeReferences(response.data);
          const confirmButtonTranslation = vm.callPlanReferences && vm.callPlanReferences.hasReferences ? 'OKAY_TEXT' : 'DELETE_TEXT';
          vm.confirmButtonText = $translate.instant(confirmButtonTranslation);
        }, 800);
      }).catch(function () {
        vm.checkReferencesText = 'DELETE_CALL_PLAN_MODAL_CALL_PLAN_CHECK_ASSOCIATION_ERROR_TEXT';
        bsLoadingOverlayService.stop();
      });
    }

    function _setViewDetails(showSpecificRecordDetails) {
      let loadingTranslation = 'CALL_PLANS_HEADER_LOADING';

      if (showSpecificRecordDetails) {
        loadingTranslation = 'CALL_PLAN_HEADER_LOADING';
      } else {
        $translate('CALL_PLANS_HEADER').then(function (translation) {
          vm.widgetTitle = translation;
        });
      }

      $translate(loadingTranslation).then(function (translation) {
        vm.loadingText = translation;
      });
    }

    function _deDupeReferences(references) {
      const dedupedRefs = references;
      if (dedupedRefs && dedupedRefs.ivrtrees) {
        dedupedRefs.ivrtrees = _.uniqBy(dedupedRefs.ivrtrees, 'id');
      }
      return dedupedRefs;
    }

    function _loadData() {
      if (vm.showSpecificRecordDetails) {
        return _loadCallPlan($stateParams.callPlanId);
      } else {
        return _loadCallPlans();
      }
    }

    function _loadCallPlan(callPlanId) {
      callPlanService.getCallPlan(accountsService.currentAccountId, callPlanId).then(function (callPlan) {
        vm.callPlans = [callPlan];
        vm.loading = false;
        vm.widgetTitle = callPlan.name;
        showRoutes(vm.callPlans[0]);
      });
    }

    function _loadCallPlans() {
      callPlanService.getCallPlans(accountsService.currentAccountId).then(function (callPlans) {
        vm.callPlans = callPlans;
        vm.loading = false;
      });
    }

    // Watch the items displayed in the table, if there is an active item when it changes, hide the edit form and clear active item
    let lastDisplayIds = [];
    $scope.$watch('vm.displayCallPlans', function() {
      const currentIds = (vm.displayCallPlans || []).map(function(cp) { return cp.id; }).join(',');
      if (currentIds === lastDisplayIds) return;
      lastDisplayIds = currentIds;
      if (vm.showAddNewForm || vm.showNewCallPlanRoutes) return;
      if (vm.activeCallPlan && !vm.activeCallPlan.showRoutes) hideForm(vm.activeCallPlan);
      if (vm.activeCallPlan && vm.activeCallPlan.showRoutes) hideRoutes(vm.activeCallPlan);
      vm.formActive = false;
    });
  }
})();
